import { render, staticRenderFns } from "./SubmitReadings.vue?vue&type=template&id=7f63e59c"
import script from "./SubmitReadings.vue?vue&type=script&lang=js"
export * from "./SubmitReadings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports